import React from "react";
import { Layout, Tabs, Card, Modal, message, Row, Col, Button, Switch } from "antd";
import AddandEditUser from "./AddandEditUser";
import EditRoleView from "./EditRoleView";
import MiCompAPI from "../../../util/api";
import TableWrapper from '../../elements/TableWrapper';
import InviteUserDrawer from '../../User/InviteUserDrawer';
const { Content } = Layout;
const { TabPane } = Tabs;
class UserManagement extends React.Component {
  user_columns = [
    {
    title: 'First Name',
    dataIndex: 'first_Name',
    sorter: (a, b) => a.first_Name.localeCompare(b.first_Name),
    sortDirections: ["descend", "ascend"]
  }, {
    title: 'Middle Name',
    dataIndex: 'middle_Name',
    sorter: (a, b) => {
      a = a.middle_Name || '';
      b = b.middle_Name || '';
      return a.localeCompare(b);
    },
    sortDirections: ["descend", "ascend"]
  }, {
    title: 'Last Name',
    dataIndex: 'last_Name',
    sorter: (a, b) => a.last_Name.localeCompare(b.last_Name),
    sortDirections: ["descend", "ascend"]
  },
   {
    title: 'Email',
    dataIndex: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    sortDirections: ["descend", "ascend"]
  }, {
    title: 'Phone',
    dataIndex: 'phoneNo',
    render: (text, record) => text.length === 10 ? <a href={"tel:+" + text}>{"(" + text.substring(0, 3) + ") " + text.substring(3, 6) + "-" + text.substring(6)}</a> : "Invalid US Number"
  },
   {
    title: 'Role',
    dataIndex: 'userRole',
    width:'100px',
    render: (text, record) => <span style={{textOverflow:"ellipsis"}}>{text}</span>
  },{
    title: 'Actions',
    dataIndex: 'user_Id',
    render: (text, record) => <>
        <Switch defaultChecked={record["isActive"]} style={{ marginRight: '10px' }} onChange={() => this.ChangeStatusById(text)} /> 
        <Button icon="edit" onClick={() => { this.UserDefaultHandler('edit', text) }} /> 
        <Button icon="delete" onClick={() => { this.UserDefaultHandler('delete', text) }} />
        
    </>
 
}];
  columns = [{
    title: 'Role Name',
    dataIndex: 'userRoleName',
    width: '70%'
  },{
    title: 'Actions',
    dataIndex: 'id',
    render: (text, record) => <>
     
        <Button icon="edit" onClick={() => { this.EditRole(text) }} /> 
   
        <Button icon="delete" onClick={() => this.DelteRole(text)} /> 
    </>
  }
  ];
  invite_columns = [{
    title: 'First Name',
    width: '22%',
    dataIndex: 'first_Name',
  },
  {
    title: 'Middle Name',
    width: '22%',
    dataIndex: 'middle_Name',
  }, {
    title: 'Last Name',
    width: '22%',
    dataIndex: 'last_Name',
  }, {
    title: 'Email',
    width: '22%',
    dataIndex: 'email',
  },{
    title: 'Action',
    dataIndex: 'id',
    render: (record) => <Button className="mi_table-operation" onClick={() => { this.resendInvitation(record) }}>Re-Invite</Button>
  }];
  constructor(props) {
    super(props);
    this.state = {
      getroles: [],
      reports: [],
      users: [],
      roles:[],
      loading: false,
      allAgenciesLoading: true,
      useritem: null,
      isEdit: false,
      isEditRole: false,
      role_id: 0,
      isInvite: false,
      getinvitaions: [],
    }
    this.tableButtons=[];
   
      this.tableButtons.push({
        buttonType: "primary",
        content: "Invite User",
        clickHandler: () => {
          this.UserDefaultHandler('add', null);
        },
      })
   
     
    
    this.tableButtons1=[];
      this.tableButtons1.push({
        buttonType: "primary",
        content: "Add Role",
        clickHandler: () => {
          this.setState({
            isEditRole: true,
            role_id: 0,
          })
        },
      })
  
    
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  ChangeStatusById = (id) => {
    this.api.invoke("ChangeStatusById/" + id, "patch", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          message.destroy();
          message.success(data.statusMessage, 3);
        }
        else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
        this.getAgencies();
      }
    });
  }
  EditRole = (val) => {
    this.setState({
      isEditRole: true,
      role_id: val,
    })
  }
  DelteRole = (val) => {
    this.api.invoke("DeleteUserRoleById/" + val, "patch", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          message.destroy();
          message.success(data.statusMessage, 3);
          this.getroles();
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  UserDefaultHandler = (key, values) => {
    switch (key) {
      case "close":
        this.setState({
          isEdit: false,
          isInvite: false,
        })
        break;
      case "add":
        this.setState({
          isInvite: true
        })
        break;
      case 'edit':
        this.api.invoke("getuserbyid/" + values, "get", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              this.setState({
                useritem: data.data,
                isEdit: true
              })
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
          else {
          }
        });
        break;
      case 'delete':
        this.setState({ allAgenciesLoading: true });
        this.api.invoke("deleteuser/" + values, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.getUsers();
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
          else {
          }
        });
        break
      default:
        break
    }
  }
  getUsers = () => {
    this.api.invoke("getallusers", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            users: data.data
          })
          this.setState({ allAgenciesLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
      else {
      }
    });
  }
  Change = (data, type, e) => {
    if (type === "write") {
      data.write = e.target.checked;
    }
    if (type === "read") {
      data.read = e.target.checked;
    }
    if (type === "delete") {
      data.delete = e.target.checked;
    }
    this.Submitt([data]);
  }
  componentDidMount = () => {
    this.GetUserRoles();
    this.getUsers();
    this.getAllInvitations();
    this.getClientMasters();
  }
  getAllInvitations = () => {
    this.api.invoke(
      "BSU_GetAllUserInvitations",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              getinvitaions: data.data
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  resendInvitation(val) {
    this.api.invoke("ReinviteUser/" + val, "patch", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          message.destroy();
          message.success(data.statusMessage, 3);
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
      else {
        message.destroy();
        message.error("Failed to Load", 3);
      }
    });
  }
  Submitt = (values) => {
    this.api.invoke(
      "SaveandEditUserRole",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetUserRoles();
            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }, values
    );
  }
  getClientMasters() {
    this.api.invoke(
        "GetMasters",
        "post",
        (data, success) => {
            if (success) {
                this.setState({
                    roles: data.roles
                });
            }
        },
        ["ROLES"]
    );
}
  GetUserRoles = () => {
    this.setState({
      loading: true,
    })
    this.api.invoke(
      "GetUserRoles",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              getroles: data.data
              , loading: false,
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  submitHandlerUserInvite = (data,callback) => {
    this.api.invoke(
      "UpsertInviteUser",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              isInvite: false
            })
            this.getAllInvitations();
            message.destroy();
            message.success(data.statusMessage, 3);
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        }
      }, data
    );
  }
  submitHandlerUser = (data,callback) => {
    this.api.invoke(
      "UpdateUser",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              isEdit: false
            })
            this.getUsers();
            message.destroy();
            message.success(data.statusMessage, 3);
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        }
      }, data
    );
  }
  SaveRole=(formData)=>{
    this.api.invoke(
      "SaveandEditUserRole",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.GetUserRoles();
            this.setState({ isEditRole: false })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      formData
    );
  }
  render() {
    return (
      <Content>
        {(this.state.isInvite) ? <Modal
          visible={this.state.isInvite}
        > <InviteUserDrawer roles={this.state.roles} closeDrawerHandler={this.UserDefaultHandler} submitHandler={this.submitHandlerUserInvite} width={500} /></Modal> : null}
        {(this.state.isEdit) ? <Modal
          visible={this.state.isEdit}
        > <AddandEditUser useritem={this.state.useritem} roles={this.state.roles} closeDrawerHandler={this.UserDefaultHandler} submitHandler={this.submitHandlerUser} width={500} /></Modal> : null}
        <Card style={{ minHeight: "100vh", background: "#f0f0f0" }}>
          <Tabs defaultActiveKey="user-role-mapping">
            <TabPane tab="Users" key="user-role-mapping">
              <Row>
                <Col span={24}>
                  <Card type="inner">
                    <TableWrapper rowkey="id" columns={this.user_columns} data={this.state.allAgenciesLoading ? null : this.state.users} loading={this.state.allAgenciesLoading} title="Users" buttons={this.tableButtons} column_search="userName" />
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Invitation's" key="inv">
              <Row>
                <Col span={24}>
                  <Card type="inner">
                    <TableWrapper rowKey="id" title="Manage Invitations"
                      bordered={true} columns={this.invite_columns} data={this.state.getinvitaions}
                      search={true}
                    />
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Roles" key="roles">
              <Row>
                <Col span={24}>
                  <Card type="inner">
                    {this.state.isEditRole ? <EditRoleView closeRole={() =>  this.setState({ isEditRole: false })} submitHandler={this.SaveRole} role_id={this.state.role_id}></EditRoleView>
                      :
                      <TableWrapper rowKey="id" title="Manage Roles"
                        bordered={true} columns={this.columns} data={this.state.loading ? null : this.state.getroles} loading={this.state.loading}
                        search={true} buttons={this.tableButtons1}
                      />}
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Card>
      </Content>
    );
  }
};
export default UserManagement;
